import type { VacationModality } from '../../models/vacation.types';

export interface ModalityOption {
    value: VacationModality;
    label: string;
    description: string;
}

export const MODALITY_OPTIONS: ModalityOption[] = [
    { value: '30', label: '30 dias corridos', description: 'Período único' },
    { value: '10+20', label: '10 + 20 dias', description: 'Dois períodos' },
    { value: '15+15', label: '15 + 15 dias', description: 'Dois períodos' },
];

export const SELL_DAYS_LABEL = 'Desejo manifestar interesse em vender 1/3 das férias (abono pecuniário)';
export const SELL_DAYS_HINT =
    'Sujeito à aprovação. A confirmação vem junto com o agendamento. Com o abono, as férias passam a ser de 20 dias em um único período.';

export const SELL_SINGLE_PERIOD_OPTION: ModalityOption = {
    value: '30',
    label: '30 dias corridos',
    description: 'Período único — 20 de gozo + 10 em abono',
};

export const MODALITY_REQUIRED_HINT = 'Selecione uma modalidade para escolher as datas.';

export function buildPartialBalanceOption(days: number): ModalityOption {
    return {
        value: '30',
        label: `${days} dia${days !== 1 ? 's' : ''} corridos`,
        description: 'Período único — saldo restante',
    };
}

export function buildPartialBalanceHint(days: number): string {
    return `Seu saldo é de ${days} dia${days !== 1 ? 's' : ''} e deve ser usado em um único período.`;
}

export const PERIOD_FIELD_LABELS = {
    singleStart: 'Início das férias',
    firstStart: 'Início do 1º período',
    firstEnd: 'Fim do 1º período',
    secondStart: 'Início do 2º período',
    secondEnd: 'Fim do 2º período',
};

export const MANAGER_EMAIL_LABEL = 'Gestor Raro';
export const MANAGER_EMAIL_PLACEHOLDER = 'gestor@rarolabs.com.br';
export const CLIENT_EMAIL_LABEL = 'E-mail do cliente';
export const CLIENT_EMAIL_PLACEHOLDER = 'cliente@empresa.com.br';
export const CLIENT_EMAIL_NEXT_PLACEHOLDER = 'Adicionar outro e-mail';
export const CLIENT_EMAIL_HINT = 'Digite o e-mail e aperte Enter. Até 5.';
export const CLIENT_EMAIL_LIMIT_MESSAGE = 'Limite de 5 e-mails';

export const SEGMENT_SUMMARY_HEADERS = {
    period: 'Período',
    days: 'Dias de gozo',
    start: 'Início',
    returnDate: 'Retorno',
    total: 'Total',
};
